<template>
  <div class="get-in-touch-section">
    <div>
      <h2 class="text-xl text-semibold">
        Still have questions?
      </h2>
      <p class="sub-title text-lg text-regular">
        Contact our support team.
      </p>
    </div>
    <a
      target="_blank"
      href="https://us-help-attendee.peatix.com/support/tickets/new"
    ><BaseButton :size="BtnSize[1]">Get in touch</BaseButton></a>
  </div>
</template>
<style scoped lang="scss">
.get-in-touch-section {
    display: flex;
    flex-wrap: wrap;
    gap: spacings-get(8);
    justify-content: space-between;
    padding: spacings-get(6);
    background-color: colors-get(gray, 50);
    @include border-radius-default;

    .sub-title {
        color: colors-get(gray, 600);
    }
}
</style>